//@flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { RouteUtil } from 'utils/RouteUtil';
import { useMediaQuery } from 'react-responsive';
import RecommendedCarousel from 'components/organisms/recommendedCarousel';
import RecommendedMobileCarousel from 'components/organisms/recommendedMobileCarousel';
import './styles.scss';

type Props = {
  data: Array,
};

const AllProperties = (props: Props) => {
  const { data, breadcrumbList } = props;
  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1224px)',
  });
  const isBigScreen = useMediaQuery({ query: '(min-device-width: 1824px)' });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({
    query: '(max-device-width: 1224px)',
  });
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  const goToProjectDetails = urlSlug => {
    if (data.type === 'workcations') {
      RouteUtil.setRouteChange(props, `/workcations/${urlSlug}`);
    } else if (data.type === 'Landcraft') {
      RouteUtil.setRouteChange(props, `/Landcraft/${urlSlug}`);
    } else {
      RouteUtil.setRouteChange(props, `/${urlSlug}`);
    }
    window.location.reload();
  };

  return (
    <div id={'properties'}>
      {(isDesktopOrLaptop || isBigScreen || isPortrait === false) && (
        <>
          <RecommendedCarousel
            recommendedList={data.data}
            fetchTitle={<h2>Our Projects</h2>}
            isDefinedRoute={false}
            onClick={data => goToProjectDetails(data.urlSlug)}
            displayProjectOverlay={true}
            projectList={data.projectList}
            type={data.type}
            showFilter={true}
            breadcrumbList={breadcrumbList}
          />
        </>
      )}

      {(isTabletOrMobileDevice || isTabletOrMobile) && isPortrait === true && (
        <RecommendedMobileCarousel
          recommendedList={data.data}
          fetchTitle={
            <h2 className={'project-recommended-section'}>Our Projects</h2>
          }
          isDisplayLocationIcon={true}
          isDefinedRoute={false}
          onClick={data => goToProjectDetails(data.urlSlug)}
          displayProjectOverlay={false}
          type={data.type}
          showFilter={true}
          breadcrumbList={breadcrumbList}
        />
      )}
    </div>
  );
};

export default withRouter(AllProperties);
